define(['angular', '../ilmn-ui-utils/module', 'ui.bootstrap'], function(angular, ilmnUiUtils) {
    'use strict';

    var MODULE_NAME = 'ilmn-ui-nav';

    return angular
        .module(MODULE_NAME, [ilmnUiUtils, 'ui.bootstrap'])
        .config(['$httpProvider', 'ilmnUiCookieUtilProvider', ModuleConfig])
        .run(['$log', ModuleRun])
        .name;

    function ModuleConfig($httpProvider,ilmnUiCookieUtilProvider) {

        var psToken = ilmnUiCookieUtilProvider.get('psToken');

        var interceptor = ['$rootScope', '$q', function ($rootScope, $q) {
            return {
                request: function (config) {
                    // if ((config.url.indexOf('platform-services') === 0)) {
                    //     config.headers.Authorization = 'Bearer '+ psToken
                    // }
                    config.headers.Authorization = 'Bearer '+ psToken;
                    return config;
                },
                response: function (response) {
                    return response;
                },
                responseError: function (response) {
                    return $q.reject(response);
                }
            }
        }];
        $httpProvider.interceptors.push(interceptor);

    }

    function ModuleRun($log) {
        $log.info('Started nav module.');
    }
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-nav/module.js
// module id = 4
// module chunks = 0